import { render, staticRenderFns } from "./CardReclamacion.vue?vue&type=template&id=23ab4b10&"
import script from "./CardReclamacion.vue?vue&type=script&lang=js&"
export * from "./CardReclamacion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports